module.exports = __webpack_public_path__ + "static/media/Logo_5.0e9ef91b.png";